export default "__VITE_ASSET__D_7X$M$Z__";